<template>
  <div class="partyAllience">
    <div class="banner">
      <img :src="banner" @click="goReport()" />
    </div>
    <div class="choose-icon">
      <div
        class="choose-template"
        v-for="choose in chooses"
        :key="choose.name"
        @click="goCompany(choose.name)"
      >
        <img :src="choose.imgUrl" alt />
        <p v-text="choose.name"></p>
      </div>
    </div>
    <div class="banner">
      <img src="@/assets/index/partyAllience/dp-banner.png" @click="goIntrodution()" />
    </div>
    <div class="title">活动报名</div>
    <div class="slide-box">
      <div class="slide-template" v-for="slide in slides" :key="slide.id" @click="goApply(slide)">
        <div class="slide-left">
          <img :src="slide.memo | filterC" alt />
        </div>
        <div class="slide-right">
          <p>{{slide.headline}}</p>
          <p>{{slide.createtime | times}}</p>
        </div>
      </div>
    </div>

    <div class="title">往期活动</div>
    <div class="news-list">
      <div
        class="news-template"
        v-for="news in sevenLine"
        :key="news.c4idd"
        @click="goDetail(news.c4idd)"
      >
        <div class="news-left">
          <img :src="news.imgUrl" alt v-if="news.imgUrl==null?false:true" />
        </div>
        <div class="news-right">
          <p>{{news.c4headline}}</p>
          <p>
            <span style="margin-right:.3rem;float:right">{{news.c4createtime|times}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [
        {
          name: "财富成员",
          imgUrl: require("@/assets/index/partyAllience/dp-sy-lm2.png")
        },
        {
          name: "财富生活",
          imgUrl: require("@/assets/index/partyAllience/dp-sy-lm3.png")
        },
        {
          name: "财富活动",
          imgUrl: require("@/assets/index/partyAllience/dp-sy-lm4.png")
        },
        {
          name: "财富风采",
          imgUrl: require("@/assets/index/partyAllience/dp-sy-lm5.png")
        }
      ],
      slides: [
      ],
      sevenLine: [],
      banner:
        sessionStorage.getItem("id") == "26842"
          ? require("@/assets/index/partyAllience/dp-sy-lmAdmin.png")
          : require("@/assets/index/partyAllience/dp-sy-lm1.png"),
      showPosi: true,
      tempActive: "",
      moveWay: {
        top: 8 + "rem",
        left: 0.7 + "rem",
        position: "fixed"
      },
      clickTime: 0
    };
  },
  methods: {
    goDetail(newsid) {
      this.$router.push({
        path: "publicDetail",
        query: { title: "新闻动态", id: newsid, dbnum: 1 }
      });
    },
    goCompany(name) {
      switch (name) {
        case "财富成员":
          this.$router.push({
            path: "partyCompany",
            query: { title: name }
          });
          break;
        case "财富生活":
          this.$router.push({
            path: "allienceLive",
            query: { title: name }
          });
          break;
        case "财富活动":
          this.$router.push({
            path: "allienceActive",
            query: { title: name }
          });
          break;
        case "财富风采":
          this.$router.push({
            path: "allienceMienList",
            query: { title: name }
          });
          break;
        default:
          break;
      }
    },
    goApply(slide) {
      const { receivetime = '', id = 0, memo = '' } = slide
      this.$router.push({
        path: "/allienceActive/allienceActiveReport",
        query: { title: "财富活动报名", receivetime, id, memo }
        // query: { title: "财富活动报名", slide: slide }
      });
    },
    getMsg() {
      this.axios({
        method: "get",
        url: "/api/Main/getActivity",
        params:{ name:'财富中心综合党委' }
      }).then(e => {
          // console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.slides = e.data.msg;
              this.slides.filter(item => {
                if (item.id == 19822) { this.tempActive = item; }
              });
              break;
            default:
              break;
          }
        })
        .catch(err => { console.log("err", err); });
    },
    getEverThings() {
      this.axios({
        method:'get',
        url:'/api/Main/Activity',
        params:{ name:'财富中心综合党委' }
      }).then(e => {
          //console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.sevenLine = e.data.msg;
              this.sevenLine.forEach(item => {
                let text = item.c4memo;
                if (item.c4memo.indexOf("img") > -1) {
                  let textStart = item.c4memo.indexOf("img");
                  let textSub = text.substring(textStart + 9);
                  let textEnd = textSub.indexOf("title=");
                  let imgUrl = textSub.substring(0, textEnd - 2);
                  item.imgUrl = imgUrl;
                }
              });
              break;
            case 3:
              this.$router.push("login");
              break;
            default:
              alert('服务器错误,请稍后重试')
              break;
          }
        })
        .catch(err => { console.log(err); });
    },
    goReport() {
      this.$router.push({
        path: "/outSide/qrcodeScan",
        query: { title: "党员报到" }
      });
    },
    goIntrodution() {
      this.$router.push({
        path: "/introduction/introduction",
        query: { title: "综合党委简介" }
      });
    },
  },
  mounted: function() {
    this.getEverThings();
    this.getMsg();
  },
  filters: {
    filterC: function(value) {
      // console.log(value);
      let txt;
      if (value) {
        let num = value.indexOf('src="');
        let sub1 = value.substring(num);
        let num1 = sub1.indexOf('" ');
        txt = sub1.substring(5, num1);
      }
      return txt;
    }
  }
};
</script>

<style lang="scss" scoped>
.partyAllience {
  &-posi {
    &-box {
      img {
        &:nth-child(1) {
          width: 0.4rem;
          height: 0.4rem;
          position: absolute;
          right: 0rem;
          top: -0.2rem;
        }
        &:nth-child(2) {
          width: 5rem;
          height: 3.2rem;
          margin-top: 0.2rem;
        }
      }

      position: relative;
    }
  }
  .news-list {
    .news-template {
      width: 94%;
      margin: 0 auto;
      display: flex;
      margin-bottom: 0.2rem;
      background: #fff;
      padding: 0.2rem 0;
      //   align-items: center;
      .news-right {
        width: 100%;
        margin-left: 0.2rem;
        p:nth-child(1) {
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          margin-bottom: 0.3rem;
          line-height: 1.8;
        }
        p:nth-child(2) {
          // border-top: 0.01rem solid #e6e6e6;
          padding-top: 0.2rem;
          color: #999999;
          font-size: 0.26rem;
        }
      }
      .news-left {
        img {
          width: 2.4rem;
          height: 2rem;
        }
      }
    }
    margin-top: 0.3rem;
  }

  .slide-box {
    .slide-template {
      .slide-right {
        p {
          &:nth-child(1) {
            line-height: 1.5;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &:nth-child(2) {
            position: absolute;
            bottom: 0;
            color: #999999;
            line-height: 2;
          }
        }
        width: 2rem;
        position: relative;
        margin-left: 0.2rem;
      }
      .slide-left {
        img {
          width: 2rem;
          height: 100%;
        }
        width: 2rem;
        height: 2.5rem;
      }
      display: flex;
      width: 60%;
      background: #fff;
      border-radius: 0.1rem;
      margin-top: 0.15rem;
      margin-left: 0.2rem;
    }
    display: flex;
    width: 100%;
    overflow-x: scroll;
  }

  .title {
    font-weight: bold;
    line-height: 3;
    background: #fff;
    padding-left: 0.2rem;
    margin-top: 0.2rem;
  }
  .choose-icon {
    .choose-template {
      img {
        width: 1.08rem;
        height: 1.08rem;
        border-radius: 50%;
      }
      text-align: center;
      width: 25%;
    }
    display: flex;
    background: #fff;
    padding: 0.3rem 0;
  }
  .banner {
    img {
      width: 94%;
    }
    text-align: center;
    background: #fff;
    padding-top: 0.2rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  position: relative;
}
</style>

